import { KeyboardBackspaceOutlined } from '@mui/icons-material';
import { Box, Grid, SxProps, Typography } from '@mui/material';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import SideContentCard from '@components/SideContentCard';
import useUser from '@utils/context/user';

interface YearlyDecisionsProps {
    decisionYear: number;
}

const cardSx: SxProps = {
    '&:hover, &:focus': {
        backgroundColor: 'grey.600',
    },
    border: 'none',
    color: 'text.secondary',
    cursor: 'pointer',
    mb: 1,
};

const gridSx: SxProps = {
    alignItems: 'center',
    color: 'grey.300',
    display: 'flex',
    mr: 2,
};

const YearlyDecisions: FC<YearlyDecisionsProps> = ({ decisionYear }) => {
    const { info: user } = useUser();
    const { t } = useTranslation('decision');

    /**
     * The yearly decisions appear only if the user is not logged in
     * LIV-2236
     */
    if (user) {
        return null;
    }

    return (
        <Box>
            <SideContentCard dataTestId="yearly-decisions" sx={cardSx}>
                <Grid container>
                    <Grid sx={gridSx} item>
                        <KeyboardBackspaceOutlined />
                    </Grid>
                    <Grid item xs>
                        <Link href={`/sitemap/decisions/${decisionYear}`} rel="noopener noreferrer">
                            <Typography component="h4" sx={{ fontWeight: 'medium' }}>
                                {t('yearlyDecisions', { year: decisionYear })}
                            </Typography>
                        </Link>
                    </Grid>
                </Grid>
            </SideContentCard>
        </Box>
    );
};

export default YearlyDecisions;
